import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface ParentInsight {
  slug: string;
  name: string;
  value: any;
}

// GET /insights/parent — parent mobile app's own AI Insights endpoint (see
// Dashboard.js / api.js). Gated on the PARENT_AI_INSIGHT extension service
// (see schoolExtensionServicePermissions on the logged-in student) before
// ever being called — see isParentAiInsightEnabled() below.
@Injectable({ providedIn: 'root' })
export class ParentInsightsService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  getInsights(lang: string) {
    const authToken = this.getAuthToken();
    const headers = authToken ? new HttpHeaders().append('authToken', authToken) : undefined;
    return this.http.get(`${this.base}/get/insights/parent`, { params: { lang }, headers });
  }

  private getAuthToken(): string | null {
    const raw = localStorage.getItem('authToken');
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }

  // Mirrors the mobile app's Dashboard.js gate: only the selected student's
  // schoolExtensionServicePermissions entry for PARENT_AI_INSIGHT, set to
  // ENABLED, allows the insights call at all.
  isParentAiInsightEnabled(studentDetail: any): boolean {
    const permissions: any[] = studentDetail?.schoolExtensionServicePermissions || [];
    const entry = permissions.find(p => p.serviceName === 'PARENT_AI_INSIGHT');
    return !!entry && entry.serviceStatus === 'ENABLED';
  }
}
